import {gql} from '@apollo/client'
import {ITEM_RESPONSE_FRAGMENT} from '../fragments/itemResponse'

export const ITEM_RESPONSES = gql`
  ${ITEM_RESPONSE_FRAGMENT}
  query itemResponses($everplanId: ID!) {
    itemResponses(everplanId: $everplanId) {...ItemResponseFragment}
  }
`
